import React from 'react';

const Car = ({ className }) => (
  <svg viewBox="0 0 601 600" className={className}>
    <g className="lidar">
      <path
        d="M300 600C465.685 600 600 465.685 600 300C600 134.315 465.685 0 300 0C134.315 0 0 134.315 0 300C0 465.685 134.315 600 300 600Z"
        fill="url(#lidar_radial)"
      />
    </g>
    <g className="camera-e">
      <g style={{ mixBlendMode: 'multiply', animationDelay: '200ms' }}>
        <path
          d="M329.89 270.15L541.03 101.6C491.52 39.67 415.34 0 329.89 0C244.44 0 168.26 39.67 118.76 101.6L329.89 270.15Z"
          fill="url(#camera_e_0_linear)"
        />
      </g>
      <path
        d="M563.154 163.712L329.232 298.841L330.582 301.179L564.505 166.05L563.154 163.712Z"
        fill="black"
      />
      <g style={{ mixBlendMode: 'multiply', animationDelay: '400ms' }}>
        <path
          d="M329.89 300L370.29 32.88C448.67 44.79 521.12 90.92 563.85 164.92C606.57 238.92 610.3 324.73 581.42 398.57L329.89 300Z"
          fill="url(#camera_e_1_linear)"
        />
      </g>
      <path d="M502.23 159.36V160.92H496.23V159.36H502.23Z" fill="black" />
      <path
        d="M518.22 152.41C517.78 152.39 517.22 152.43 516.62 152.53C513.24 153.07 511.49 155.5 511.13 158.12H511.18C511.93 157.1 513.27 156.27 515.02 156.27C517.81 156.27 519.78 158.31 519.78 161.37C519.78 164.29 517.81 166.96 514.5 166.96C511.15 166.96 508.93 164.34 508.93 160.23C508.93 157.12 510.02 154.66 511.6 153.11C512.91 151.82 514.66 151.02 516.66 150.78C517.29 150.68 517.83 150.66 518.21 150.66V152.41H518.22ZM517.62 161.52C517.62 159.26 516.33 157.9 514.36 157.9C513.07 157.9 511.86 158.68 511.27 159.84C511.15 160.08 511.05 160.38 511.05 160.76C511.07 163.36 512.29 165.3 514.55 165.3C516.38 165.32 517.62 163.78 517.62 161.52Z"
        fill="black"
      />
      <path
        d="M532.2 158.63C532.2 164 530.18 166.97 526.71 166.97C523.62 166.97 521.51 164.08 521.46 158.85C521.46 153.53 523.77 150.63 526.98 150.63C530.28 150.63 532.2 153.6 532.2 158.63ZM523.62 158.87C523.62 162.98 524.88 165.31 526.83 165.31C528.99 165.31 530.04 162.76 530.04 158.72C530.04 154.83 529.07 152.28 526.83 152.28C524.98 152.29 523.62 154.57 523.62 158.87Z"
        fill="black"
      />
      <path
        d="M540.37 147.6C540.37 148.82 539.37 149.74 537.94 149.74C536.48 149.74 535.51 148.79 535.51 147.6C535.51 146.39 536.43 145.39 537.97 145.39C539.45 145.38 540.37 146.36 540.37 147.6ZM536.75 147.6C536.75 148.23 537.21 148.84 537.92 148.84C538.65 148.84 539.11 148.28 539.11 147.55C539.11 146.85 538.65 146.26 537.89 146.26C537.19 146.26 536.75 146.89 536.75 147.6Z"
        fill="black"
      />
      <path
        d="M330.558 328.693L329.208 331.031L563.158 466.106L564.508 463.768L330.558 328.693Z"
        fill="black"
      />
      <g style={{ mixBlendMode: 'multiply', animationDelay: '600ms' }}>
        <path
          d="M329.89 329.85L370.29 596.97C448.67 585.06 521.12 538.93 563.85 464.93C606.57 390.93 610.3 305.12 581.42 231.28L329.89 329.85Z"
          fill="url(#camera_e_2_linear)"
        />
      </g>
      <path d="M528.44 421.81V423.37H522.44V421.81H528.44Z" fill="black" />
      <path
        d="M534.91 415.35H534.86L532.11 416.83L531.7 415.2L535.15 413.35H536.97V429.15H534.9V415.35H534.91Z"
        fill="black"
      />
      <path
        d="M542.74 429.15V427.84L544.42 426.21C548.45 422.37 550.3 420.33 550.3 417.95C550.3 416.35 549.55 414.86 547.19 414.86C545.76 414.86 544.57 415.59 543.84 416.2L543.16 414.69C544.23 413.79 545.81 413.09 547.61 413.09C551.01 413.09 552.45 415.42 552.45 417.68C552.45 420.6 550.34 422.95 547.01 426.16L545.77 427.33V427.38H552.84V429.15H542.74Z"
        fill="black"
      />
      <path
        d="M565.74 421.08C565.74 426.45 563.72 429.42 560.25 429.42C557.16 429.42 555.05 426.53 555 421.3C555 415.98 557.31 413.08 560.52 413.08C563.81 413.09 565.74 416.05 565.74 421.08ZM557.15 421.33C557.15 425.44 558.41 427.77 560.36 427.77C562.52 427.77 563.57 425.22 563.57 421.18C563.57 417.29 562.6 414.74 560.36 414.74C558.52 414.74 557.15 417.02 557.15 421.33Z"
        fill="black"
      />
      <path
        d="M573.9 410.05C573.9 411.27 572.9 412.19 571.47 412.19C570.01 412.19 569.04 411.24 569.04 410.05C569.04 408.84 569.96 407.84 571.5 407.84C572.98 407.83 573.9 408.81 573.9 410.05ZM570.28 410.05C570.28 410.68 570.74 411.29 571.45 411.29C572.18 411.29 572.64 410.73 572.64 410C572.64 409.3 572.18 408.71 571.42 408.71C570.72 408.71 570.28 409.34 570.28 410.05Z"
        fill="black"
      />
      <path d="M301.39 329.85H298.69V600H301.39V329.85Z" fill="black" />
      <g style={{ mixBlendMode: 'multiply', animationDelay: '800ms' }}>
        <path
          d="M300.04 329.85L88.91 498.4C138.41 560.33 214.59 600 300.04 600C385.49 600 461.67 560.33 511.17 498.4L300.04 329.85Z"
          fill="url(#camera_e_3_linear)"
        />
      </g>
      <path
        d="M313.24 570.59H313.19L310.44 572.07L310.03 570.44L313.48 568.59H315.3V584.39H313.23V570.59H313.24Z"
        fill="black"
      />
      <path
        d="M323.98 576.08C322.21 575.25 321.45 573.89 321.45 572.53C321.45 570.03 323.57 568.32 326.36 568.32C329.42 568.32 330.98 570.22 330.98 572.21C330.98 573.55 330.3 575 328.36 575.9V575.97C330.33 576.75 331.54 578.16 331.54 580.05C331.54 582.82 329.18 584.64 326.17 584.64C322.86 584.64 320.87 582.7 320.87 580.39C320.87 578.4 322.06 576.96 324.01 576.14L323.98 576.08ZM329.38 580.29C329.38 578.39 328.04 577.45 325.9 576.84C324.05 577.38 323.06 578.61 323.06 580.12C322.99 581.7 324.2 583.11 326.22 583.11C328.14 583.11 329.38 581.91 329.38 580.29ZM323.5 572.39C323.48 573.97 324.69 574.82 326.51 575.31C327.87 574.85 328.92 573.88 328.92 572.44C328.92 571.18 328.17 569.86 326.25 569.86C324.47 569.86 323.5 571.02 323.5 572.39Z"
        fill="black"
      />
      <path
        d="M344.06 576.32C344.06 581.69 342.04 584.66 338.57 584.66C335.48 584.66 333.37 581.77 333.32 576.54C333.32 571.22 335.63 568.32 338.84 568.32C342.14 568.33 344.06 571.29 344.06 576.32ZM335.48 576.57C335.48 580.68 336.74 583.01 338.69 583.01C340.85 583.01 341.9 580.46 341.9 576.42C341.9 572.53 340.93 569.98 338.69 569.98C336.84 569.98 335.48 572.26 335.48 576.57Z"
        fill="black"
      />
      <path
        d="M352.23 565.29C352.23 566.51 351.23 567.43 349.8 567.43C348.34 567.43 347.37 566.48 347.37 565.29C347.37 564.08 348.29 563.08 349.83 563.08C351.31 563.08 352.23 564.05 352.23 565.29ZM348.61 565.29C348.61 565.92 349.07 566.53 349.78 566.53C350.51 566.53 350.97 565.97 350.97 565.24C350.97 564.54 350.51 563.95 349.75 563.95C349.05 563.95 348.61 564.58 348.61 565.29Z"
        fill="black"
      />
      <path
        d="M269.506 328.645L35.5831 463.774L36.9336 466.112L270.857 330.982L269.506 328.645Z"
        fill="black"
      />
      <g style={{ mixBlendMode: 'multiply', animationDelay: '1000ms' }}>
        <path
          d="M270.19 329.85L229.79 596.97C151.41 585.06 78.96 538.93 36.23 464.93C-6.48999 390.93 -10.22 305.12 18.66 231.28L270.19 329.85Z"
          fill="url(#camera_e_4_linear)"
        />
      </g>
      <path
        d="M34.92 415.35H34.87L32.12 416.83L31.71 415.2L35.16 413.35H36.98V429.15H34.91V415.35H34.92Z"
        fill="black"
      />
      <path
        d="M42.75 429.15V427.84L44.43 426.21C48.46 422.37 50.31 420.33 50.31 417.95C50.31 416.35 49.56 414.86 47.2 414.86C45.77 414.86 44.58 415.59 43.85 416.2L43.17 414.69C44.24 413.79 45.82 413.09 47.62 413.09C51.02 413.09 52.46 415.42 52.46 417.68C52.46 420.6 50.35 422.95 47.02 426.16L45.78 427.33V427.38H52.85V429.15H42.75Z"
        fill="black"
      />
      <path
        d="M65.75 421.08C65.75 426.45 63.73 429.42 60.26 429.42C57.17 429.42 55.06 426.53 55.01 421.3C55.01 415.98 57.32 413.08 60.53 413.08C63.83 413.09 65.75 416.05 65.75 421.08ZM57.17 421.33C57.17 425.44 58.43 427.77 60.38 427.77C62.54 427.77 63.59 425.22 63.59 421.18C63.59 417.29 62.62 414.74 60.38 414.74C58.53 414.74 57.17 417.02 57.17 421.33Z"
        fill="black"
      />
      <path
        d="M73.92 410.05C73.92 411.27 72.92 412.19 71.49 412.19C70.03 412.19 69.06 411.24 69.06 410.05C69.06 408.84 69.98 407.84 71.52 407.84C73 407.83 73.92 408.81 73.92 410.05ZM70.3 410.05C70.3 410.68 70.76 411.29 71.47 411.29C72.2 411.29 72.66 410.73 72.66 410C72.66 409.3 72.2 408.71 71.44 408.71C70.73 408.71 70.3 409.34 70.3 410.05Z"
        fill="black"
      />
      <path
        d="M36.9079 163.764L35.5579 166.103L269.508 301.178L270.858 298.839L36.9079 163.764Z"
        fill="black"
      />
      <g style={{ mixBlendMode: 'multiply', animationDelay: '1200ms' }}>
        <path
          d="M270.19 300L229.79 32.88C151.41 44.79 78.96 90.92 36.24 164.93C-6.47998 238.93 -10.21 324.74 18.67 398.58L270.19 300Z"
          fill="url(#camera_e_5_linear)"
        />
      </g>
      <path
        d="M69.17 152.41C68.73 152.39 68.17 152.43 67.57 152.53C64.19 153.07 62.44 155.5 62.08 158.12H62.13C62.88 157.1 64.22 156.27 65.97 156.27C68.76 156.27 70.73 158.31 70.73 161.37C70.73 164.29 68.76 166.96 65.46 166.96C62.11 166.96 59.89 164.34 59.89 160.23C59.89 157.12 60.98 154.66 62.56 153.11C63.87 151.82 65.62 151.02 67.62 150.78C68.25 150.68 68.79 150.66 69.18 150.66V152.41H69.17ZM68.56 161.52C68.56 159.26 67.27 157.9 65.3 157.9C64.01 157.9 62.8 158.68 62.21 159.84C62.09 160.08 61.99 160.38 61.99 160.76C62.01 163.36 63.23 165.3 65.49 165.3C67.32 165.32 68.56 163.78 68.56 161.52Z"
        fill="black"
      />
      <path
        d="M83.15 158.63C83.15 164 81.13 166.97 77.66 166.97C74.57 166.97 72.46 164.08 72.41 158.85C72.41 153.53 74.72 150.63 77.93 150.63C81.23 150.63 83.15 153.6 83.15 158.63ZM74.57 158.87C74.57 162.98 75.83 165.31 77.78 165.31C79.94 165.31 80.99 162.76 80.99 158.72C80.99 154.83 80.02 152.28 77.78 152.28C75.93 152.29 74.57 154.57 74.57 158.87Z"
        fill="black"
      />
      <path
        d="M91.32 147.6C91.32 148.82 90.32 149.74 88.89 149.74C87.43 149.74 86.46 148.79 86.46 147.6C86.46 146.39 87.38 145.39 88.92 145.39C90.4 145.38 91.32 146.36 91.32 147.6ZM87.7 147.6C87.7 148.23 88.16 148.84 88.87 148.84C89.6 148.84 90.06 148.28 90.06 147.55C90.06 146.85 89.6 146.26 88.84 146.26C88.14 146.26 87.7 146.89 87.7 147.6Z"
        fill="black"
      />
      <g style={{ mixBlendMode: 'multiply', animationDelay: '1400ms' }}>
        <path
          d="M270.19 270.15L481.32 101.6C431.82 39.67 355.64 0 270.19 0C184.74 0 108.56 39.67 59.06 101.6L270.19 270.15Z"
          fill="url(#camera_e_6_linear)"
        />
      </g>
      <path d="M301.39 0H298.69V270.15H301.39V0Z" fill="black" />
      <g style={{ mixBlendMode: 'multiply' }}>
        <path
          d="M300.04 270.15L511.17 101.6C461.67 39.67 385.49 0 300.04 0C214.59 0 138.41 39.67 88.91 101.6L300.04 270.15Z"
          fill="url(#camera_e_7_linear)"
        />
      </g>
      <path
        d="M319.12 28.72C319.12 34.09 317.1 37.06 313.63 37.06C310.54 37.06 308.43 34.17 308.38 28.94C308.38 23.62 310.69 20.72 313.9 20.72C317.2 20.73 319.12 23.69 319.12 28.72ZM310.54 28.96C310.54 33.07 311.8 35.4 313.75 35.4C315.91 35.4 316.96 32.85 316.96 28.81C316.96 24.92 315.99 22.37 313.75 22.37C311.9 22.38 310.54 24.66 310.54 28.96Z"
        fill="black"
      />
      <path
        d="M327.29 17.69C327.29 18.91 326.29 19.83 324.86 19.83C323.4 19.83 322.43 18.88 322.43 17.69C322.43 16.48 323.35 15.48 324.89 15.48C326.37 15.47 327.29 16.45 327.29 17.69ZM323.67 17.69C323.67 18.32 324.13 18.93 324.84 18.93C325.57 18.93 326.03 18.37 326.03 17.64C326.03 16.94 325.57 16.35 324.81 16.35C324.1 16.35 323.67 16.98 323.67 17.69Z"
        fill="black"
      />
      <path
        d="M428.24 152.61C395.37 116.78 348.64 96.23 300.05 96.23C251.46 96.23 204.73 116.78 171.86 152.61L169.4 150.35C202.9 113.83 250.53 92.88 300.06 92.88C349.59 92.88 397.21 113.83 430.72 150.35L428.24 152.61Z"
        fill="white"
      />
      <path d="M434.06 144.23L437.28 160.6L421.5 155.21L434.06 144.23Z" fill="white" />
      <path d="M166.03 144.23L162.81 160.6L178.59 155.21L166.03 144.23Z" fill="white" />
      <path
        d="M300.04 121.56C314.958 121.56 327.05 109.467 327.05 94.55C327.05 79.6328 314.958 67.54 300.04 67.54C285.123 67.54 273.03 79.6328 273.03 94.55C273.03 109.467 285.123 121.56 300.04 121.56Z"
        fill="white"
      />
      <path
        d="M282.32 90.96H282.29L280.46 91.95L280.18 90.86L282.48 89.63H283.7V100.16H282.32V90.96V90.96Z"
        fill="black"
      />
      <path
        d="M294.55 94.79C294.55 98.37 293.21 100.35 290.89 100.35C288.83 100.35 287.42 98.42 287.39 94.94C287.39 91.39 288.93 89.46 291.07 89.46C293.27 89.45 294.55 91.43 294.55 94.79ZM288.83 94.95C288.83 97.69 289.67 99.24 290.97 99.24C292.41 99.24 293.11 97.54 293.11 94.85C293.11 92.26 292.46 90.56 290.97 90.56C289.74 90.56 288.83 92.08 288.83 94.95Z"
        fill="black"
      />
      <path
        d="M295.85 100.17V99.29L296.97 98.2C299.66 95.64 300.89 94.28 300.89 92.69C300.89 91.62 300.39 90.63 298.82 90.63C297.86 90.63 297.07 91.12 296.58 91.52L296.13 90.52C296.84 89.92 297.9 89.45 299.09 89.45C301.36 89.45 302.32 91.01 302.32 92.51C302.32 94.45 300.91 96.03 298.69 98.17L297.86 98.95V98.98H302.58V100.16H295.85V100.17Z"
        fill="black"
      />
      <path
        d="M304.28 99.32C304.28 98.74 304.69 98.3 305.25 98.3C305.82 98.3 306.21 98.72 306.21 99.32C306.21 99.9 305.82 100.34 305.22 100.34C304.67 100.34 304.28 99.91 304.28 99.32Z"
        fill="black"
      />
      <path
        d="M309.47 94.62C308.29 94.07 307.78 93.16 307.78 92.25C307.78 90.58 309.19 89.45 311.05 89.45C313.09 89.45 314.13 90.71 314.13 92.04C314.13 92.93 313.68 93.9 312.38 94.5V94.55C313.69 95.07 314.5 96.01 314.5 97.27C314.5 99.12 312.93 100.33 310.92 100.33C308.72 100.33 307.39 99.03 307.39 97.49C307.39 96.16 308.18 95.2 309.48 94.65L309.47 94.62ZM313.07 97.43C313.07 96.17 312.18 95.53 310.75 95.13C309.52 95.49 308.85 96.31 308.85 97.32C308.8 98.37 309.61 99.31 310.96 99.31C312.24 99.31 313.07 98.51 313.07 97.43ZM309.14 92.16C309.12 93.21 309.93 93.78 311.15 94.1C312.06 93.79 312.75 93.14 312.75 92.19C312.75 91.35 312.25 90.47 310.97 90.47C309.79 90.47 309.14 91.25 309.14 92.16Z"
        fill="black"
      />
      <path
        d="M319.99 87.43C319.99 88.24 319.32 88.86 318.37 88.86C317.4 88.86 316.75 88.23 316.75 87.43C316.75 86.62 317.37 85.96 318.39 85.96C319.37 85.95 319.99 86.6 319.99 87.43ZM317.57 87.43C317.57 87.85 317.88 88.26 318.35 88.26C318.84 88.26 319.14 87.89 319.14 87.4C319.14 86.93 318.83 86.54 318.33 86.54C317.86 86.54 317.57 86.96 317.57 87.43Z"
        fill="black"
      />
    </g>
    <g className="car">
      <path
        d="M270.19 260.98C279.43 259.45 289.5 258.61 300.04 258.61C310.58 258.61 320.65 259.45 329.89 260.98C329.89 260.98 334.31 244.76 336.24 226.27C338.11 208.4 310.58 205.74 300.04 205.74C289.5 205.74 261.97 208.4 263.84 226.27C265.78 244.76 270.19 260.98 270.19 260.98Z"
        fill="white"
      />
      <path
        d="M300.04 345.74C286.37 345.74 274.29 342.14 266.95 336.61V347.45C266.95 357.18 281.77 365.08 300.04 365.08C318.32 365.08 333.13 357.19 333.13 347.45V336.61C325.8 342.13 313.71 345.74 300.04 345.74Z"
        fill="white"
      />
      <path
        d="M347.09 240.03C346.37 239.31 345.63 238.66 344.89 238.08V203.71C344.89 183.99 323.55 169.4 300.05 169.4C276.55 169.4 255.21 183.99 255.21 203.71V238.08C254.47 238.66 253.73 239.31 253.01 240.03C248.79 244.25 246.87 249.17 248.71 251.01C249.92 252.22 252.43 251.81 255.21 250.21V355C255.21 365.81 259.53 382.29 300.05 382.29C340.57 382.29 344.89 365.81 344.89 355V250.21C347.67 251.81 350.18 252.21 351.39 251.01C353.23 249.16 351.31 244.25 347.09 240.03Z"
        fill="black"
      />
      <path
        d="M270.19 260.98C279.43 259.45 289.5 258.61 300.04 258.61C310.58 258.61 320.65 259.45 329.89 260.98C329.89 260.98 334.31 244.76 336.24 226.27C338.11 208.4 310.58 205.74 300.04 205.74C289.5 205.74 261.97 208.4 263.84 226.27C265.78 244.76 270.19 260.98 270.19 260.98Z"
        fill="#FFE576"
      />
      <path
        d="M335.538 369.702C338.701 366.539 340.196 362.904 338.876 361.584C337.556 360.264 333.921 361.759 330.758 364.922C327.595 368.085 326.101 371.719 327.421 373.039C328.741 374.359 332.375 372.865 335.538 369.702Z"
        fill="#FFD600"
      />
      <path
        d="M272.655 373.037C273.975 371.717 272.481 368.083 269.318 364.919C266.155 361.756 262.52 360.262 261.2 361.582C259.88 362.902 261.375 366.536 264.538 369.699C267.701 372.863 271.335 374.357 272.655 373.037Z"
        fill="#FFD600"
      />
      <path
        d="M300.04 345.74C286.37 345.74 274.29 342.14 266.95 336.61V347.45C266.95 357.18 281.77 365.08 300.04 365.08C318.32 365.08 333.13 357.19 333.13 347.45V336.61C325.8 342.13 313.71 345.74 300.04 345.74Z"
        fill="#FFE576"
      />
      <path
        d="M327.03 211.16C324.69 209.93 322.07 208.97 319.37 208.22L290.12 258.87C293.24 258.71 296.41 258.63 299.62 258.62L327.03 211.16Z"
        fill="white"
      />
      <path
        d="M319.37 208.22C313.22 206.51 306.66 205.91 302.07 205.77L270.19 260.98C276.49 259.94 283.17 259.22 290.13 258.87L319.37 208.22Z"
        fill="#FFD600"
      />
      <path
        d="M305.27 345.56L294.16 364.8C296.07 364.98 298.03 365.08 300.04 365.08C301.18 365.08 302.3 365.05 303.41 364.99L315.46 344.12C312.25 344.82 308.84 345.31 305.27 345.56Z"
        fill="white"
      />
      <path
        d="M294.16 364.8L305.27 345.56C303.56 345.68 301.81 345.74 300.04 345.74C295.51 345.74 291.16 345.34 287.1 344.61L277.9 360.55C282.38 362.7 287.97 364.21 294.16 364.8Z"
        fill="#FFD600"
      />
      <path
        d="M336.723 194.775C338.043 193.455 335.691 188.963 331.47 184.741C327.248 180.52 322.756 178.167 321.436 179.487C320.116 180.807 322.468 185.3 326.69 189.521C330.911 193.743 335.403 196.095 336.723 194.775Z"
        fill="#FFD600"
      />
      <path
        d="M329.08 191.69V182.57C325.67 179.77 322.51 178.42 321.44 179.49C320.12 180.81 322.47 185.3 326.69 189.52C327.49 190.31 328.29 191.04 329.08 191.69Z"
        fill="white"
      />
      <path
        d="M273.39 189.522C277.612 185.3 279.964 180.808 278.644 179.488C277.324 178.168 272.832 180.52 268.61 184.742C264.389 188.964 262.037 193.456 263.357 194.776C264.677 196.096 269.169 193.744 273.39 189.522Z"
        fill="#FFD600"
      />
      <path
        d="M271 191.69V182.57C274.41 179.77 277.57 178.42 278.64 179.49C279.96 180.81 277.61 185.3 273.39 189.52C272.6 190.31 271.79 191.04 271 191.69Z"
        fill="white"
      />
      <path
        d="M270.19 272.85C271.681 272.85 272.89 271.641 272.89 270.15C272.89 268.659 271.681 267.45 270.19 267.45C268.699 267.45 267.49 268.659 267.49 270.15C267.49 271.641 268.699 272.85 270.19 272.85Z"
        fill="#FFD600"
      />
      <path
        d="M329.89 272.85C331.381 272.85 332.59 271.641 332.59 270.15C332.59 268.659 331.381 267.45 329.89 267.45C328.399 267.45 327.19 268.659 327.19 270.15C327.19 271.641 328.399 272.85 329.89 272.85Z"
        fill="#FFD600"
      />
      <path
        d="M300.04 272.85C301.531 272.85 302.74 271.641 302.74 270.15C302.74 268.659 301.531 267.45 300.04 267.45C298.549 267.45 297.34 268.659 297.34 270.15C297.34 271.641 298.549 272.85 300.04 272.85Z"
        fill="#FFD600"
      />
      <path
        d="M300.04 302.7C301.531 302.7 302.74 301.491 302.74 300C302.74 298.509 301.531 297.3 300.04 297.3C298.549 297.3 297.34 298.509 297.34 300C297.34 301.491 298.549 302.7 300.04 302.7Z"
        fill="white"
      />
      <path
        d="M270.19 332.55C271.681 332.55 272.89 331.341 272.89 329.85C272.89 328.359 271.681 327.15 270.19 327.15C268.699 327.15 267.49 328.359 267.49 329.85C267.49 331.341 268.699 332.55 270.19 332.55Z"
        fill="#FFD600"
      />
      <path
        d="M270.19 302.7C271.681 302.7 272.89 301.491 272.89 300C272.89 298.509 271.681 297.3 270.19 297.3C268.699 297.3 267.49 298.509 267.49 300C267.49 301.491 268.699 302.7 270.19 302.7Z"
        fill="#FFD600"
      />
      <path
        d="M300.04 332.55C301.531 332.55 302.74 331.341 302.74 329.85C302.74 328.359 301.531 327.15 300.04 327.15C298.549 327.15 297.34 328.359 297.34 329.85C297.34 331.341 298.549 332.55 300.04 332.55Z"
        fill="#FFD600"
      />
      <path
        d="M329.89 332.55C331.381 332.55 332.59 331.341 332.59 329.85C332.59 328.359 331.381 327.15 329.89 327.15C328.399 327.15 327.19 328.359 327.19 329.85C327.19 331.341 328.399 332.55 329.89 332.55Z"
        fill="#FFD600"
      />
      <path
        d="M329.89 302.7C331.381 302.7 332.59 301.491 332.59 300C332.59 298.509 331.381 297.3 329.89 297.3C328.399 297.3 327.19 298.509 327.19 300C327.19 301.491 328.399 302.7 329.89 302.7Z"
        fill="#FFD600"
      />
      <path
        d="M300.04 376.38C301.531 376.38 302.74 375.171 302.74 373.68C302.74 372.189 301.531 370.98 300.04 370.98C298.549 370.98 297.34 372.189 297.34 373.68C297.34 375.171 298.549 376.38 300.04 376.38Z"
        fill="#FDA82B"
      />
    </g>
    <g className="camera-i">
      <path
        d="M270.19 272.85C271.681 272.85 272.89 271.641 272.89 270.15C272.89 268.659 271.681 267.45 270.19 267.45C268.699 267.45 267.49 268.659 267.49 270.15C267.49 271.641 268.699 272.85 270.19 272.85Z"
        fill="#00BFA5"
        style={{ transformOrigin: '270px 270px' }}
      />
      <path
        d="M300.04 272.85C301.531 272.85 302.74 271.641 302.74 270.15C302.74 268.659 301.531 267.45 300.04 267.45C298.549 267.45 297.34 268.659 297.34 270.15C297.34 271.641 298.549 272.85 300.04 272.85Z"
        fill="#00BFA5"
        style={{ transformOrigin: '300.03px 270.15px' }}
      />
      <path
        d="M329.89 272.85C331.381 272.85 332.59 271.641 332.59 270.15C332.59 268.659 331.381 267.45 329.89 267.45C328.399 267.45 327.19 268.659 327.19 270.15C327.19 271.641 328.399 272.85 329.89 272.85Z"
        fill="#00BFA5"
        style={{ transformOrigin: '329.88px 270.15px' }}
      />
      <path
        d="M270.19 302.7C271.681 302.7 272.89 301.491 272.89 300C272.89 298.509 271.681 297.3 270.19 297.3C268.699 297.3 267.49 298.509 267.49 300C267.49 301.491 268.699 302.7 270.19 302.7Z"
        fill="#00BFA5"
        style={{ transformOrigin: '270.19px 300px' }}
      />
      <path
        d="M329.89 302.7C331.381 302.7 332.59 301.491 332.59 300C332.59 298.509 331.381 297.3 329.89 297.3C328.399 297.3 327.19 298.509 327.19 300C327.19 301.491 328.399 302.7 329.89 302.7Z"
        fill="#00BFA5"
        style={{ transformOrigin: '329.88px 300px' }}
      />
      <path
        d="M270.19 332.55C271.681 332.55 272.89 331.341 272.89 329.85C272.89 328.359 271.681 327.15 270.19 327.15C268.699 327.15 267.49 328.359 267.49 329.85C267.49 331.341 268.699 332.55 270.19 332.55Z"
        fill="#00BFA5"
        style={{ transformOrigin: '270.19px 329.84px' }}
      />
      <path
        d="M300.04 332.55C301.531 332.55 302.74 331.341 302.74 329.85C302.74 328.359 301.531 327.15 300.04 327.15C298.549 327.15 297.34 328.359 297.34 329.85C297.34 331.341 298.549 332.55 300.04 332.55Z"
        fill="#00BFA5"
        style={{ transformOrigin: '300.03px 329.84px' }}
      />
      <path
        d="M329.89 332.55C331.381 332.55 332.59 331.341 332.59 329.85C332.59 328.359 331.381 327.15 329.89 327.15C328.399 327.15 327.19 328.359 327.19 329.85C327.19 331.341 328.399 332.55 329.89 332.55Z"
        fill="#00BFA5"
        style={{ transformOrigin: '329.88px 329.84px' }}
      />
    </g>
    <g className="imu">
      <path
        d="M364.498 425.74C385.678 443.91 399.088 470.86 399.088 500.95C399.088 555.65 354.738 600 300.038 600C245.338 600 200.988 555.65 200.988 500.95C200.988 470.86 214.408 443.91 235.578 425.74L298.028 371.89C298.518 371.33 299.238 370.98 300.038 370.98C300.838 370.98 301.558 371.34 302.048 371.89L364.498 425.74Z"
        fill="#83DFD2"
      />
      <path
        d="M300.04 376.38C301.531 376.38 302.74 375.171 302.74 373.68C302.74 372.189 301.531 370.98 300.04 370.98C298.549 370.98 297.34 372.189 297.34 373.68C297.34 375.171 298.549 376.38 300.04 376.38Z"
        fill="#83DFD2"
      />
      <path
        d="M300.038 600C354.742 600 399.088 555.654 399.088 500.95C399.088 446.246 354.742 401.9 300.038 401.9C245.334 401.9 200.988 446.246 200.988 500.95C200.988 555.654 245.334 600 300.038 600Z"
        fill="#83DFD2"
      />
      <path
        d="M300.04 592.08C350.37 592.08 391.17 551.28 391.17 500.95C391.17 450.62 350.37 409.82 300.04 409.82C249.71 409.82 208.91 450.62 208.91 500.95C208.91 551.28 249.71 592.08 300.04 592.08Z"
        fill="#00BFA5"
      />
      <path
        d="M275.547 546.95C277.387 548.01 279.837 547.87 281.687 546.76L331.857 519.35L300.067 516.03L275.547 546.95Z"
        fill="black"
      />
      <path
        d="M220.498 515.17L275.558 546.96C277.908 548.32 281.278 547.72 283.088 545.63L305.838 519.35L242.268 482.65L219.518 508.93C217.708 511.02 218.148 513.81 220.498 515.17Z"
        fill="white"
      />
      <path
        d="M260.018 517.21L243.398 507.62L245.428 505.27L260.518 513.98L272.518 500.12L275.568 501.88L262.558 516.91C261.998 517.56 260.868 517.69 260.018 517.21Z"
        fill="#E3B33A"
      />
      <path
        d="M249.879 507.14C250.172 504.739 247.961 502.494 244.94 502.125C241.92 501.757 239.234 503.404 238.941 505.805C238.648 508.207 240.859 510.452 243.879 510.82C246.9 511.189 249.586 509.541 249.879 507.14Z"
        fill="#E3B33A"
      />
      <path
        d="M246.236 506.695C246.333 505.895 245.595 505.146 244.586 505.023C243.578 504.9 242.681 505.449 242.583 506.25C242.485 507.05 243.224 507.799 244.233 507.922C245.241 508.045 246.138 507.496 246.236 506.695Z"
        fill="white"
      />
      <path
        d="M379.357 486.66L352.147 470.95L331.867 519.36L379.817 488.57C380.737 488.09 380.657 487.41 379.357 486.66Z"
        fill="black"
      />
      <path
        d="M379.356 486.66L324.936 455.24C322.406 453.78 316.266 452.6 311.216 452.6H294.336L357.906 489.3H374.786C379.826 489.3 381.876 488.11 379.356 486.66Z"
        fill="#FFD600"
      />
      <path
        d="M357.897 489.3L294.327 452.59L268.297 482.65L331.867 519.35L357.897 489.3Z"
        fill="white"
      />
      <path
        d="M301.609 501.88L308.119 494.37C308.679 493.72 308.449 492.8 307.609 492.32C306.769 491.84 305.629 491.97 305.069 492.61L298.559 500.12L301.609 501.88Z"
        fill="#E3B33A"
      />
      <path
        d="M298.526 460.8C296.446 461.99 295.156 464.56 295.156 468.21C295.156 471.86 296.436 475.9 298.506 479.48L306.586 493.48L314.666 488.81L314.746 488.76L315.046 488.59L315.126 488.54L315.206 488.49L315.286 488.44L315.366 488.39L315.446 488.34L315.746 488.17L315.826 488.12L315.906 488.07L315.986 488.02L316.066 487.97L316.366 487.8L316.446 487.75L316.526 487.7L316.606 487.65L316.686 487.6L316.766 487.55L317.066 487.38L317.146 487.33L317.226 487.28L317.306 487.23L317.386 487.18L317.466 487.13L317.766 486.96L317.846 486.91L317.926 486.86L318.006 486.81L318.086 486.76L318.386 486.59L318.466 486.54L318.546 486.49L318.626 486.44L318.706 486.39L318.786 486.34L318.826 486.32C320.896 485.13 322.176 482.56 322.176 478.92C322.176 471.63 317.056 462.76 310.746 459.12C307.576 457.29 304.716 457.12 302.636 458.33L298.526 460.8Z"
        fill="black"
      />
      <path
        d="M306.586 461.62C312.896 465.27 318.016 474.13 318.016 481.42C318.016 485.07 316.736 487.63 314.666 488.82L306.586 493.49L298.506 479.49C296.436 475.91 295.156 471.87 295.156 468.22C295.156 460.92 300.276 457.97 306.586 461.62Z"
        fill="#00BFA5"
      />
      <path
        d="M309.275 479.479C310.762 478.62 310.761 475.834 309.273 473.256C307.785 470.678 305.372 469.284 303.885 470.143C302.397 471.002 302.398 473.788 303.886 476.366C305.375 478.944 307.787 480.338 309.275 479.479Z"
        fill="white"
      />
      <path d="M331.866 519.35L268.296 482.65H242.266L305.836 519.35H331.866Z" fill="#FFD600" />
      <path d="M275.577 501.88L272.527 500.12H298.557L301.607 501.88H275.577Z" fill="black" />
    </g>
    <g className="lidar">
      <path
        className="lidar-dot"
        d="M300.04 302.7C301.531 302.7 302.74 301.491 302.74 300C302.74 298.509 301.531 297.3 300.04 297.3C298.549 297.3 297.34 298.509 297.34 300C297.34 301.491 298.549 302.7 300.04 302.7Z"
        fill="#00BFA5"
        style={{ transformOrigin: '300px 300px' }}
      />
    </g>
    <defs>
      <radialGradient
        id="lidar_radial"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(300 300) scale(300)"
      >
        <stop offset="0.00146743" stopColor="#FFF1B6" />
        <stop offset="0.1879" stopColor="#FFF1B3" />
        <stop offset="0.3377" stopColor="#FFEFA9" />
        <stop offset="0.4748" stopColor="#FFED98" />
        <stop offset="0.6043" stopColor="#FFE980" />
        <stop offset="0.7285" stopColor="#FFE461" />
        <stop offset="0.8487" stopColor="#FFDF3B" />
        <stop offset="0.9635" stopColor="#FFD810" />
        <stop offset="1" stopColor="#FFD600" />
      </radialGradient>
      <linearGradient
        id="camera_e_0_linear"
        x1="329.894"
        y1="270.149"
        x2="329.894"
        y2="6.44084e-05"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00146743" stopColor="#FFF1B6" />
        <stop offset="0.1879" stopColor="#FFF1B3" />
        <stop offset="0.3377" stopColor="#FFEFA9" />
        <stop offset="0.4748" stopColor="#FFED98" />
        <stop offset="0.6043" stopColor="#FFE980" />
        <stop offset="0.7285" stopColor="#FFE461" />
        <stop offset="0.8487" stopColor="#FFDF3B" />
        <stop offset="0.9635" stopColor="#FFD810" />
        <stop offset="1" stopColor="#FFD600" />
      </linearGradient>
      <linearGradient
        id="camera_e_1_linear"
        x1="330.181"
        y1="300.003"
        x2="564.13"
        y2="164.929"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00146743" stopColor="#FFF1B6" />
        <stop offset="0.1879" stopColor="#FFF1B3" />
        <stop offset="0.3377" stopColor="#FFEFA9" />
        <stop offset="0.4748" stopColor="#FFED98" />
        <stop offset="0.6043" stopColor="#FFE980" />
        <stop offset="0.7285" stopColor="#FFE461" />
        <stop offset="0.8487" stopColor="#FFDF3B" />
        <stop offset="0.9635" stopColor="#FFD810" />
        <stop offset="1" stopColor="#FFD600" />
      </linearGradient>
      <linearGradient
        id="camera_e_2_linear"
        x1="330.205"
        y1="329.999"
        x2="564.154"
        y2="465.074"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00146743" stopColor="#FFF1B6" />
        <stop offset="0.1879" stopColor="#FFF1B3" />
        <stop offset="0.3377" stopColor="#FFEFA9" />
        <stop offset="0.4748" stopColor="#FFED98" />
        <stop offset="0.6043" stopColor="#FFE980" />
        <stop offset="0.7285" stopColor="#FFE461" />
        <stop offset="0.8487" stopColor="#FFDF3B" />
        <stop offset="0.9635" stopColor="#FFD810" />
        <stop offset="1" stopColor="#FFD600" />
      </linearGradient>
      <linearGradient
        id="camera_e_3_linear"
        x1="300.043"
        y1="329.852"
        x2="300.043"
        y2="600"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00146743" stopColor="#FFF1B6" />
        <stop offset="0.1879" stopColor="#FFF1B3" />
        <stop offset="0.3377" stopColor="#FFEFA9" />
        <stop offset="0.4748" stopColor="#FFED98" />
        <stop offset="0.6043" stopColor="#FFE980" />
        <stop offset="0.7285" stopColor="#FFE461" />
        <stop offset="0.8487" stopColor="#FFDF3B" />
        <stop offset="0.9635" stopColor="#FFD810" />
        <stop offset="1" stopColor="#FFD600" />
      </linearGradient>
      <linearGradient
        id="camera_e_4_linear"
        x1="270.055"
        y1="330.1"
        x2="36.1066"
        y2="465.175"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00146743" stopColor="#FFF1B6" />
        <stop offset="0.1879" stopColor="#FFF1B3" />
        <stop offset="0.3377" stopColor="#FFEFA9" />
        <stop offset="0.4748" stopColor="#FFED98" />
        <stop offset="0.6043" stopColor="#FFE980" />
        <stop offset="0.7285" stopColor="#FFE461" />
        <stop offset="0.8487" stopColor="#FFDF3B" />
        <stop offset="0.9635" stopColor="#FFD810" />
        <stop offset="1" stopColor="#FFD600" />
      </linearGradient>
      <linearGradient
        id="camera_e_5_linear"
        x1="270.174"
        y1="299.847"
        x2="36.2257"
        y2="164.773"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00146743" stopColor="#FFF1B6" />
        <stop offset="0.1879" stopColor="#FFF1B3" />
        <stop offset="0.3377" stopColor="#FFEFA9" />
        <stop offset="0.4748" stopColor="#FFED98" />
        <stop offset="0.6043" stopColor="#FFE980" />
        <stop offset="0.7285" stopColor="#FFE461" />
        <stop offset="0.8487" stopColor="#FFDF3B" />
        <stop offset="0.9635" stopColor="#FFD810" />
        <stop offset="1" stopColor="#FFD600" />
      </linearGradient>
      <linearGradient
        id="camera_e_6_linear"
        x1="270.191"
        y1="270.149"
        x2="270.191"
        y2="6.44084e-05"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00146743" stopColor="#FFF1B6" />
        <stop offset="0.1879" stopColor="#FFF1B3" />
        <stop offset="0.3377" stopColor="#FFEFA9" />
        <stop offset="0.4748" stopColor="#FFED98" />
        <stop offset="0.6043" stopColor="#FFE980" />
        <stop offset="0.7285" stopColor="#FFE461" />
        <stop offset="0.8487" stopColor="#FFDF3B" />
        <stop offset="0.9635" stopColor="#FFD810" />
        <stop offset="1" stopColor="#FFD600" />
      </linearGradient>
      <linearGradient
        id="camera_e_7_linear"
        x1="300.043"
        y1="270.149"
        x2="300.043"
        y2="6.44084e-05"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.00146743" stopColor="#FFF1B6" />
        <stop offset="0.1879" stopColor="#FFF1B3" />
        <stop offset="0.3377" stopColor="#FFEFA9" />
        <stop offset="0.4748" stopColor="#FFED98" />
        <stop offset="0.6043" stopColor="#FFE980" />
        <stop offset="0.7285" stopColor="#FFE461" />
        <stop offset="0.8487" stopColor="#FFDF3B" />
        <stop offset="0.9635" stopColor="#FFD810" />
        <stop offset="1" stopColor="#FFD600" />
      </linearGradient>
    </defs>
    <style jsx>{`
      svg {
        width: 100%;
        max-width: 600px;
        height: auto;
      }
      
      .lidar,
      .camera-e,
      .camera-i,
      .lidar-dot,
      .imu {
        transition: opacity 500ms ease-out;
      }
      
      .camera-i,
      .lidar-dot,
      .imu {
        opacity: 0;
      }
      
      .lidar-hover .camera-e {
        opacity: 0;
      }
      .lidar-hover .lidar-dot {
        animation: glowCircle 1s ease-out infinite;
      }
      
      .camera-e-hover .lidar {
        opacity: 0;
      }
      .camera-e-hover .camera-e g {
        opacity: 0;
        animation: showCameaField 250ms ease-out forwards;
      }
      
      .camera-i-hover .camera-i {
        opacity: 1;
      }
      .camera-i-hover .camera-i path {
        animation: glowCircle 1s ease-out infinite !important;
      }
      .camera-i-hover .lidar,
      .camera-i-hover .camera-e {
        opacity: 0;
      }
      
      .imu-hover .imu {
        opacity: 1;
      }
      .imu-hover .lidar,
      .imu-hover .camera-e {
        opacity: 0;
      }
      
      @keyframes glowCircle {
        from {
          opacity: 1;
          transform: scale(1);
        }
        to {
          opacity: 0;
          transform: scale(4);
        }
      }
      @keyframes showCameaField {
        from {
          opacity: 0;
        }
        to {
          opacity: 1;
        }
      }
    `}</style>
  </svg>
);

export default Car;
